export default __webpack_public_path__ + "assets/docs/EjikemeDavid_CV.pdf";